
import React from "react"
import styles from "./Ai.module.scss"
import clsx from "clsx"
import AiResponseRenderer from "./ai-response-renderer"


const ChatMessagesList = ({ messages, theme, pdfCheckboxHandler, reportDetails, onClickHandler }) => {
    return (
        <div>
            {messages.map((e, i) => {
                return <div className={
                    clsx(
                        styles.aimodalmessageline,
                        { [styles.usermessageline]: e.actor === "user" },
                    )}
                    key={i}
                >
                    {e?.isMarkdown ? <AiResponseRenderer onClickHandler={onClickHandler} pdfCheckboxHandler={pdfCheckboxHandler} reportDetails={reportDetails} data={e} theme={theme} /> : <div
                        className={
                            clsx(
                                styles.aimodalmessage,
                                { [styles.usermessage]: e.actor === "user" },
                                { [styles.darkbackground]: e.actor === "user" && theme === "dark" }
                            )}
                    >
                        {e.message}
                    </div>}

                </div>
            })}
        </div>
    )
}


export default React.memo(ChatMessagesList)